// Simple browser fingerprinting to identify unique users
export const generateFingerprint = () => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillText('fingerprint', 2, 2);
  const canvasData = canvas.toDataURL();
  
  const fingerprint = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    colorDepth: screen.colorDepth,
    deviceMemory: navigator.deviceMemory || 'unknown',
    hardwareConcurrency: navigator.hardwareConcurrency || 'unknown',
    screenResolution: `${screen.width}x${screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    platform: navigator.platform,
    canvasFingerprint: canvasData.substring(0, 50)
  };
  
  // Create hash from fingerprint
  const fingerprintString = JSON.stringify(fingerprint);
  let hash = 0;
  for (let i = 0; i < fingerprintString.length; i++) {
    const char = fingerprintString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  return Math.abs(hash).toString(36);
};

export const hasCompletedSurvey = (policyId) => {
  const completed = localStorage.getItem(`survey_completed_${policyId}`);
  return completed === 'true';
};

export const markSurveyCompleted = (policyId) => {
  localStorage.setItem(`survey_completed_${policyId}`, 'true');
  localStorage.setItem(`survey_completed_date_${policyId}`, new Date().toISOString());
};

export const getCompletedSurveys = () => {
  const completedIds = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('survey_completed_') && !key.includes('_date_')) {
      const policyId = key.replace('survey_completed_', '');
      if (localStorage.getItem(key) === 'true') {
        completedIds.push(policyId);
      }
    }
  }
  return completedIds;
};
